import { Typography, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import ModalErrorFetch from '../../../components/UI/ModalErrorFetch';
import { CompleteOmboardingFour } from '../../../components/completeOmborarding/CompleteOmboardingFour';
import { CompleteOmboardingOne } from '../../../components/completeOmborarding/CompleteOmboardingOne';
import { CompleteOmboardingTree } from '../../../components/completeOmborarding/CompleteOmboardingTree';
import { CompleteOmboardingTreeForeign } from '../../../components/completeOmborarding/CompleteOmboardingTreeForeign';
import { CompleteOmboardingTwo } from '../../../components/completeOmborarding/CompleteOmboardingTwo';
import useModal from '../../../hooks/custom/useModal';
import { onRefresh } from '../../../utils/refreshPage';
import { ErrorBoundaryXcala } from '../../../components/ErrorBoundaryXcala';

export const alreadyDone = (currentStep, newStep) => {
  return currentStep <= newStep ? true : false;
};

export const NewCompleteRegisterStepper = ({
  stepper,
  setSteppercolor,
  setstepper,
  foreign,
  setForeign,
}) => {
  const { isShowing, toggle } = useModal();
  const theme = useTheme();
  const onBoardingData = useSelector(state => state.onboarding.data);
  const [errors, setErrors] = useState({
    title: '',
    subtitle: '',
    routeName: '',
  });

  const getValue = name => {
    const obj = onBoardingData?.detail?.find(item => item.Name === name);
    return obj?.Value ? obj.Value : '';
  };

  const messageCustom = (
    <Typography>
      Hemos tenido problemas para validar tu información, por favor escribenos un email a
      <Typography
        component='span'
        sx={{
          color: theme.palette.primary.main,
          fontWeight: theme.typography.titleText.fontWeight,
        }}>
        {' '}
        contacto@xcala.com{' '}
      </Typography>
      para poder solucionar este inconveniente
    </Typography>
  );

  useEffect(() => {
    setForeign(getValue('custom:expiration'));
  }, [stepper]);

  const Error = (
    <ModalErrorFetch
      message={messageCustom}
      open={!isShowing}
      onClose={toggle}
      refresh={onRefresh}
    />
  );

  return (
    <>
      {stepper === 1 ? (
        <CompleteOmboardingOne
          setstepper={setstepper}
          stepper={stepper}
          setSteppercolor={setSteppercolor}
        />
      ) : (
        ''
      )}

      {stepper === 2 ? (
        <CompleteOmboardingTwo
          setstepper={setstepper}
          stepper={stepper}
          setSteppercolor={setSteppercolor}
        />
      ) : (
        ''
      )}

      {stepper === 3 && !foreign ? (
        <CompleteOmboardingTree
          setstepper={setstepper}
          stepper={stepper}
          setSteppercolor={setSteppercolor}
          setErrors={setErrors}
        />
      ) : (
        ''
      )}

      {stepper === 3 && foreign ? <CompleteOmboardingTreeForeign /> : ''}

      {stepper === 4 ? (
        <CompleteOmboardingFour
          setstepper={setstepper}
          stepper={stepper}
          setSteppercolor={setSteppercolor}
        />
      ) : (
        ''
      )}

      {stepper === 5 ? { Error } : ''}
    </>
  );
};
